import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import * as Api from "../../../appApi/AppApi";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";

function* workerUpdateListing(payLoad) {
  console.log(
    " Payload:: " + JSON.stringify(payLoad)
  );
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.UPDATE_LISTING,
      payLoad.data
    );
    console.log(
      "Worker: => Response:: " +
        JSON.stringify(response)
    );
    yield put(memberAction.createActionOf(memberType.UPDATE_LISTING_SUCCESS,1,response));
  } catch (error) {
    console.error("Worker: => Error::" + error.message);
    yield put(memberAction.createActionOf(memberType.UPDATE_LISTING_FAILED,2,error));
  }
}

export const watchUpdateListing= takeLatest(
  memberType.UPDATE_LISTING,
  workerUpdateListing
);
